import { getQrMfa } from '../../utils/api';
import { decryptData } from '../../utils/encryption';
import { FAILED, LOADING, SUCCESS } from './constants';

export function setFailedAction({ key, message, error, code }) {
  return { type: FAILED, key, message, error, code };
}

export function setLoadingAction({ key, isLoading = true }) {
  return { type: LOADING, key, isLoading };
}

export function setSuccessAction({
  key,
  data,
  initial = true,
  message = '',
  success = true
}) {
  return { type: SUCCESS, key, data, initial, message, success };
}

export function fetchQrMfa() {
  return async (dispatch) => {
    const key = 'dataQRMfa';
    try {
      dispatch(setLoadingAction({ key, isLoading: true }));
      const response = await getQrMfa();
      const data = response.data;
      const decryptedData = decryptData(data.qrContent);
      const splitSec = decryptedData.split('secret=')?.[1];
      dispatch(setSuccessAction({ key, data: { ...data, uri: decryptedData, qrCode: splitSec } }));
    } catch (error) {
      dispatch(setFailedAction(
        { key, message: error?.data?.message || error.message, code: error?.data?.code || 0 }
      ));
      dispatch(setLoadingAction({ key, isLoading: false }));
    }
  };
}
